import React, { useState } from 'react';
import DraggableModal from '../DraggableModal';
import { TextareaInput } from '../../Inputs';
import { ButtonPrimary } from '../../Buttons';
import toast from 'react-hot-toast';

export default function CommandSchedulingModal({
  isOpen,
  setIsOpen,
  startPosition,
  onScheduleButtonClicked,
}) {
  const [scheduledTime, setScheduledTime] = useState('');
  const [commands, setCommands] = useState('');
  const [repeatInterval, setRepeatInterval] = useState('');

  const generateBlock = (scheduledTime, commands, repeatInterval) => {
    // Convert scheduledTime to a Unix timestamp
    const unixTime = Math.floor(new Date(scheduledTime).getTime() / 1000);

    // Set the repeat interval, default to -1 if not provided or empty
    const repeatEvery =
      repeatInterval && !isNaN(repeatInterval) ? repeatInterval : -1;

    // Generate the block format
    const block = `STARTBLOCK min_start_time=${unixTime} repeat_every=${repeatEvery}\n${commands}\nENDBLOCK`;

    return block;
  };

  const handleSchedule = () => {
    if (scheduledTime && commands) {
      onScheduleButtonClicked(
        generateBlock(scheduledTime, commands, repeatInterval)
      );
    } else {
      toast.error('');
    }
  };

  return (
    <DraggableModal
      title="Command Scheduling Tool"
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      startPosition={startPosition}
      style={{ width: '500px' }}
    >
      <div className="overflow-y-auto space-y-6">
        {/* Step 1: Enter the date and time for scheduling */}
        <div>
          <label className="block font-medium mb-2">Schedule Date/Time:</label>
          <input
            type="datetime-local"
            value={scheduledTime}
            onChange={(e) => setScheduledTime(e.target.value)}
            className="w-full border border-gray-300 rounded-md p-2"
          />
        </div>

        {/* Step 2: Enter repeat interval */}
        <div>
          <label className="block font-medium mb-2">
            Repeat every (seconds, optional):
          </label>
          <input
            type="number"
            value={repeatInterval}
            onChange={(e) => setRepeatInterval(e.target.value)}
            placeholder="Enter interval in seconds (-1 = never, 0 = continuous)"
            className="w-full border border-gray-300 rounded-md p-2"
            min="-1"
          />
        </div>

        {/* Step 3: Enter commands */}
        <div style={{ zIndex: 500 }}>
          <label className="block font-medium mb-2">Commands:</label>
          <TextareaInput
            value={commands}
            onChange={(e) => setCommands(e.target.value)}
            placeholder="Enter your commands here..."
            className="no-drag"
            rows={6}
          />
        </div>

        {/* Step 4: Schedule button */}
        <div className="flex justify-end">
          <ButtonPrimary onClick={handleSchedule}>
            Schedule Commands
          </ButtonPrimary>
        </div>
      </div>
    </DraggableModal>
  );
}
